( function() {
	const tabNav = document.querySelector( '.facility-tabs__nav' );
	if( !tabNav ) { return; }

	const tabToggles = Array.from( tabNav.querySelectorAll( 'a' ) );
	const tabPanels = tabToggles.map( function( toggle ) {
		return document.getElementById( toggle.getAttribute( 'href' ).substring( 1 ) );
	} );

	const ACTIVE_TOGGLE = 'facility-tabs__nav--active';
	const ACTIVE_PANEL = 'facility-tabs__panel--active';
	
	activateTabFromUrl();

	tabToggles.forEach( function( toggle ) {
		toggle.addEventListener( 'click', function( e ) {
			e.preventDefault();
			activateTab( this.getAttribute( 'href' ).substring( 1 ), true );
		} );
	} );

	window.addEventListener( 'hashchange', function() {
		activateTabFromUrl();
	} );

	function activateTabFromUrl() {
		// Pull hash from the URL to get active tab
		const hash = window.location.hash;
		// clip off the beginning "#", and only take the first part as the tab id (filters use | on the hash to deliniate)
		const id = hash && hash.length > 1 ? hash.substring( 1 ).split( '|' )[0] : false;
		let tab = null;
		if( id && id.length ) {
			// the format of filters (e.g. MedicationAssistedTreatments=19) can make the selector mad; stick it in a try/catch
			try { 
				tab = tabPanels.find( function( panel ) { return panel.id == id; } );
			}
			// eslint-disable-next-line no-empty
			catch( e ) {}
		}

		if( tab ) {
			activateTab( id, true );
		} else {
			activateTab( tabToggles[0].getAttribute( 'href' ).substring( 1 ), true );
		}
	}

	function activateTab( id, noUrlUpdate ) {
		var activeTabToggle, activeTabPanel;

		// the format of filters (e.g. MedicationAssistedTreatments=19) can make the selector mad; stick it in a try/catch
		try {
			activeTabToggle = tabToggles.find( function( toggle ) { return toggle.matches( '[href="#' + id + '"]' ); } );
			activeTabPanel = tabPanels.find( function( panel ) { return panel.id == id; } );
		}
		// eslint-disable-next-line no-empty
		catch( e ) {}

		if( activeTabToggle && activeTabPanel ) {
			if( !activeTabToggle.classList.contains( ACTIVE_TOGGLE ) ) {
				tabToggles.forEach( function( toggle ) {
					if( toggle !== activeTabToggle ) { toggle.classList.remove( ACTIVE_TOGGLE ); }
				} );
				activeTabToggle.classList.add( ACTIVE_TOGGLE );

				tabPanels.forEach( function( panel ) {
					if( panel !== activeTabPanel ) { panel.classList.remove( ACTIVE_PANEL ); }
				} );
				activeTabPanel.classList.add( ACTIVE_PANEL );

				if( !noUrlUpdate ) {
					var currUrlBase = window.location.href.split( '#' )[0];
					window.history.replaceState( null, '', currUrlBase + '#' + id );
				}

				document.body.dispatchEvent( new Event( 'tabchanged' ) );
			}

			activeTabToggle.scrollIntoView( { behavior: 'smooth', block: 'center' } );
		}
	}
} )();
